export { UIGamePlayerInformationAvatar } from './UIGamePlayerInformationAvatar.tsx';
